import React from "react";
import {
  LetterCloseIcon,
  LinkIcon,
  PencilIcon,
  PrinterIcon,
  SunIcon,
  MoonIcon,
  LogoWhiteIcon,
  LogoBlackIcon,
  LogoRoundedDarkIcon,
  EyeIcon,
} from "assets";
import { useDynamicWindowWidthFor, useTailwindTheme } from "shared-hooks";
import { Theme } from "shared-types";
import { SCREEN_WIDTH_ENUM } from "component-library";
import ProfileButton from "pages/Profile/components/ProfileButton";
import EditButton from "pages/Profile/components/EditButton";

interface Props {
  isEdit?: boolean;
  toggleEdit?: () => void;
}

const ProfileHeader = ({ isEdit, toggleEdit }: Props) => {
  const isSmall = useDynamicWindowWidthFor(SCREEN_WIDTH_ENUM.SM);
  const [theme, toggleTheme] = useTailwindTheme();
  const isDark = theme === Theme.Dark;

  return (
    <header className="mb-6 flex flex-col gap-6">
      <div className="flex-end flex justify-end gap-2">
        <ProfileButton isText={!isSmall} onClick={toggleEdit}>
          {isEdit ? <EyeIcon /> : <PencilIcon />}
          {!isSmall && (
            <span className="hidden md:block">
              {isEdit ? "Public Profile" : "Edit profile"}
            </span>
          )}
        </ProfileButton>
        <ProfileButton>
          <PrinterIcon />
        </ProfileButton>
        <ProfileButton>
          <LetterCloseIcon />
        </ProfileButton>
        <ProfileButton>
          <LinkIcon />
        </ProfileButton>
        <ProfileButton
          className="border-none hover:bg-white/20 hover:text-black"
          colorEnabled={false}
          onClick={toggleTheme}
        >
          {isDark ? <SunIcon /> : <MoonIcon />}
        </ProfileButton>
      </div>
      <div>
        <h1 className="flex items-start gap-4 md:items-baseline">
          <span className="text-[48px] uppercase md:flex-none md:text-[60px]">
            Sarah Johnson{" "}
          </span>
          <span className="hidden gap-4 text-s md:flex">
            she/her | SAG-AFTRA {isEdit && <EditButton />}
          </span>
          {isDark ? (
            <LogoWhiteIcon width={210} className="ml-auto hidden lg:block" />
          ) : (
            <LogoBlackIcon width={210} className="ml-auto hidden lg:block" />
          )}
          <LogoRoundedDarkIcon
            width={64}
            height={64}
            className="ml-auto block md:hidden"
          />
        </h1>

        <p className="gap mt-2 hidden max-w-[850px] gap-4 text-sm md:flex">
          Broadway-trained theater performer with extensive experience in
          classical and contemporary productions. Recent highlights include
          Off-Broadway runs and regional theater leads.
          {isEdit && <EditButton />}
        </p>
      </div>
    </header>
  );
};

export default ProfileHeader;
